import React from 'react';
import NuRelmSpinner from '../NuRelmSpinner/NuRelmSpinner';

const SectionLoader = (props) => {
  return (
    <div style={props.loaderStyle} className="loader-rotating loader-spinner">
      <NuRelmSpinner />
    </div>
  );
}

export default SectionLoader;
